/**
 * Last lat/lng (and heading when present) per serial from FLIGHT_DATA. Module scope survives remounts; with
 * FlightProvider lifted to route level, combined with this cache, markers avoid jumping
 * between stale REST coords and live telemetry when switching e.g. /drones ↔ /orders.
 */
export type CachedFlightPosition = {
  latitude: string;
  longitude: string;
  heading?: number;
};

const bySerial: Record<string, CachedFlightPosition> = {};

export function rememberFlightPosition(
  serial: string | undefined,
  latitude: unknown,
  longitude: unknown,
  heading?: unknown
): void {
  if (!serial) return;
  const lat = latitude != null && latitude !== '' ? String(latitude) : '';
  const lng = longitude != null && longitude !== '' ? String(longitude) : '';
  if (!lat || !lng) return;
  if (Number.isNaN(Number(lat)) || Number.isNaN(Number(lng))) return;
  const prev = bySerial[serial];
  const parsedHeading =
    typeof heading === 'number' && !Number.isNaN(heading)
      ? heading
      : typeof heading === 'string' && heading !== '' && !Number.isNaN(Number(heading))
        ? Number(heading)
        : undefined;
  const h = parsedHeading !== undefined ? parsedHeading : prev?.heading;
  bySerial[serial] = { latitude: lat, longitude: lng, ...(h !== undefined ? { heading: h } : {}) };
}

export function getFlightPosition(serial: string): CachedFlightPosition | undefined {
  return bySerial[serial];
}

export function getFlightHeading(serial: string): number | undefined {
  const h = bySerial[serial]?.heading;
  return typeof h === 'number' && !Number.isNaN(h) ? h : undefined;
}
